import React, { Component } from 'react';
import lang from '../../../lang';

class Item extends Component {

    static defaultProps = {
        data: {},
        onSelectPay() {} // option选择
    }

    btnClick(data) {
        this.props.onSelectPay(data);
    }

    render() {
        let props = this.props;
        let data = props.data;
        let description = data.description;
        let count = 0;
        let newser = 0;

        if (data.type == 1) {
            description = lang.template('每人仅一次机会')
            newser = 1;
        } else if (description && description.match(/\d+/gi)) {
            count = description.match(/\d+/gi)[0];
            description = count;
        }

        let detailCls, btnCls;

        return (
            <div className="item-wrap" data-fee={data.money / 100} onClick={this.btnClick.bind(this, data)} data-newser={newser}>
                <div className="detail">
                    <div className="value">
                        <span className="num">{ data.amount - count }</span>
                        <icon></icon>
                    </div>
                    {
                        description ? <em className="tip">{description}</em> : null
                    }
                    <div className="price">{data.currencySymbol}{data.money / 100}</div>
                </div>
            </div>
        );
    }
}

export default Item;


// WEBPACK FOOTER //
// ./js/component/recharge/orderview/option-item.js